// extracted by mini-css-extract-plugin
export default {"config":"OrgConfig_config__N3kNh","config--theme":"OrgConfig_config--theme__2fRg7"};